import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-[999] grid h-screen w-screen place-items-center" }
const _hoisted_2 = { class: "bg-mono-ns-100 rounded-3xl w-[295px] xl:w-[569px] flex flex-col p-2 xl:p-4 font-sans" }
const _hoisted_3 = { class: "btn-wrapper flex flex-col xl:flex-row-reverse gap-4 xl:gap-6 items-center mb-8 xl:mb-6 px-2 xl:px-4" }


import ActionButtonComponent, {ActionButtonProps as ActionButton} from "./ActionButtonComponent.vue"
import {useContentStore} from "../store/content";
import {formatPrice, openWindow} from "../utils";

export default /*@__PURE__*/_defineComponent({
  __name: 'ContinueWatchingComponent',
  emits: ["toggle"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const contentItem = useContentStore()

let buttons: ActionButton[] = []
if(contentItem.billing && contentItem.billing.price){
    const price = formatPrice(contentItem.billing.price.amount, contentItem.billing.price?.currency)

    if(contentItem.billing?.subscription){
        buttons.push({
            label: `Watch with ${contentItem.billing.subscription}`,
            styleType: "primary",
            onclick: () => {
                if (!contentItem.links?.checkout){
                    return;
                }
                openWindow(contentItem.links.checkout.href, "purchase")
                contentItem.addToCartEvent()
                // toggle popup ?
            }
        } as ActionButton)
    }else{
        let title = `Buy ${price}`
        if (contentItem.billing.required_subscription){
            title = `${price} with ${contentItem.billing.required_subscription}`
        }

        buttons.push({
            label: title,
            styleType: "primary",
            onclick: () => {
                if (!contentItem.links?.checkout){
                    return;
                }
                openWindow(contentItem.links.checkout.href, "purchase")
                contentItem.addToCartEvent()
                // toggle popup ?
            }
        } as ActionButton)
    }

    if (contentItem.billing.has_purchase_options && contentItem.links?.purchase_options?.href){
        buttons.push({
            label: "Purchase Options",
            styleType: "optional",
            onclick: () => {
                if (!contentItem.links?.purchase_options){
                    return;
                }
                openWindow(contentItem.links.purchase_options.href, "options")
                // toggle popup ?
            }
        } as ActionButton)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "p-2.5 self-end text-mono-ps-200",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle')))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("svg", {
          class: "w-6 h-6",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M20.5 3.5C20.1 3.1 19.5 3.1 19.1 3.5L12 10.6L4.9 3.5C4.5 3.1 3.9 3.1 3.5 3.5C3.1 3.9 3.1 4.5 3.5 4.9L10.6 12L3.5 19.1C3.1 19.5 3.1 20.1 3.5 20.5C3.9 20.9 4.5 20.9 4.9 20.5L12 13.4L19.1 20.5C19.5 20.9 20.1 20.9 20.5 20.5C20.9 20.1 20.9 19.5 20.5 19.1L13.4 12L20.5 4.9C20.9 4.5 20.9 3.9 20.5 3.5Z",
            fill: "currentColor"
          })
        ], -1)
      ])),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"flex flex-col xl:flex-row gap-4 xl:gap-6 mb-6 xl:mb-10 px-2 xl:px-4 items-center xl:items-start\"><svg class=\"w-16 h-16 xl:w-[72px] xl:h-[72px]\" width=\"72\" height=\"72\" viewBox=\"0 0 72 72\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"72\" height=\"72\" rx=\"36\" fill=\"#F3F3F3\"></rect><g clip-path=\"url(#clip0_2084_11532)\"><path d=\"M20 48.3V23.7C20 21.08 22.2 19.3 24.24 20.26L50.06 32.56C52.66 33.8 52.66 38.2 50.06 39.44L24.24 51.74C22.2 52.72 20 50.92 20 48.3Z\" fill=\"#323A4B\"></path></g><defs><clipPath id=\"clip0_2084_11532\"><rect width=\"32\" height=\"32\" fill=\"white\" transform=\"translate(20 20)\"></rect></clipPath></defs></svg><div class=\"flex flex-col gap-6\"><h1 class=\"text-h3m xl:text-tf3 font-bold text-mono-white text-center xl:text-left\">Continue watching</h1><p class=\"text-p5m xl:text-smm text-mono-ps-100\">Free Preview is available for the first 10 minutes of the show.</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(buttons), (button) => {
          return (_openBlock(), _createBlock(ActionButtonComponent, {
            key: button.label,
            label: button.label,
            icon: button?.icon,
            spinner: button?.spinner,
            styleType: button.styleType,
            onclick: button?.onclick
          }, null, 8, ["label", "icon", "spinner", "styleType", "onclick"]))
        }), 128))
      ])
    ])
  ]))
}
}

})